import { render, staticRenderFns } from "./enterpriseMerchant.vue?vue&type=template&id=8828fdd8&scoped=true&"
import script from "./enterpriseMerchant.vue?vue&type=script&lang=js&"
export * from "./enterpriseMerchant.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseMerchant.vue?vue&type=style&index=0&id=8828fdd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8828fdd8",
  null
  
)

export default component.exports